export const FILTER_BUTTON_SELECTORS = {
  DATA_ACTIONS:
    '[data-action="filter"], [data-action="apply"], [data-action="search"]',
  DATA_FILTER_ACTIONS: '[data-filter-action="apply"]',

  SUBMIT_BUTTONS: 'button[type="submit"]',

  PRIMARY_BUTTONS: '.btn-primary',
  SUCCESS_BUTTONS: '.btn-success',

  SEMANTIC_CLASSES: '.filter-apply-btn, .search-btn, .apply-filter',
} as const;

export const RESET_BUTTON_SELECTORS = {
  DATA_ACTIONS: '[data-action="reset"], [data-action="clear"]',
  DATA_FILTER_ACTIONS: '[data-filter-action="reset"]',

  RESET_BUTTONS: 'button[type="reset"]',

  SECONDARY_BUTTONS: '.btn-secondary',
  OUTLINE_BUTTONS: '.btn-outline-secondary',

  SEMANTIC_CLASSES: '.filter-reset-btn, .clear-btn, .reset-filter',
} as const;

export const BUTTON_KEYWORDS = {
  RESET: ['reset', 'clear', 'limpiar', 'borrar', 'cancel'],
  APPLY: ['apply', 'search', 'filter', 'aplicar', 'buscar', 'filtrar'],
} as const;

export const EVENT_CONFIG = {
  CLICK_DELAY: 300,
  DOM_OBSERVER_DELAY: 100,
  DRAG_THRESHOLD: 5,
  CLICK_AFTER_DRAG_DELAY: 50,
  SETUP_AUTO_DETECTION_DELAY: 100,
} as const;

export const FLOATING_ICON_CONFIG = {
  MIN_POSITION: 20,
  MAX_POSITION: 80,
  DEFAULT_POSITION: 50,
  STORAGE_KEY: 'floating-icon-position',
} as const;

export const SELECTOR_CONFIDENCE_MAP = new Map<
  string,
  { type: 'filter' | 'reset'; confidence: number }
>([
  ['[data-filter-action="apply"]', { type: 'filter', confidence: 1.0 }],
  ['[data-filter-action="reset"]', { type: 'reset', confidence: 1.0 }],

  [
    '[data-action="filter"], [data-action="apply"], [data-action="search"]',
    { type: 'filter', confidence: 0.95 },
  ],
  [
    '[data-action="reset"], [data-action="clear"]',
    { type: 'reset', confidence: 0.95 },
  ],

  [
    '.filter-apply-btn, .search-btn, .apply-filter',
    { type: 'filter', confidence: 0.9 },
  ],
  [
    '.filter-reset-btn, .clear-btn, .reset-filter',
    { type: 'reset', confidence: 0.9 },
  ],

  ['.btn-success', { type: 'filter', confidence: 0.8 }],

  ['.btn-primary', { type: 'filter', confidence: 0.7 }],
  ['.btn-outline-secondary', { type: 'reset', confidence: 0.7 }],

  ['.btn-secondary', { type: 'reset', confidence: 0.6 }],
]);

export const TYPE_DETECTION_CONFIG = {
  RESET: {
    type: 'reset' as const,
    method: 'type' as const,
    confidence: 1.0,
  },
  SUBMIT: {
    type: 'filter' as const,
    method: 'type' as const,
    confidence: 0.9,
  },
} as const;

export const KEYWORD_DETECTION_CONFIG = {
  CONFIDENCE: 0.8,
  METHOD: 'keyword',
} as const;

export const DYNAMIC_COMPONENT_EVENTS = [
  { name: 'filterApplied', type: 'filter' },
  { name: 'filterReset', type: 'reset' },
] as const;

export const DYNAMIC_COMPONENT_METHODS = [
  { name: 'onApplyFilter', type: 'filter' },
  { name: 'onResetFilter', type: 'reset' },
] as const;

export const CSS_CLASSES = {
  OVERFLOW_HIDDEN: 'overflow-hidden',
  AUTO_CLOSE_BOUND: 'data-auto-close-bound',
} as const;

export const HTML_ATTRIBUTES = {
  TYPE: 'type',
  DATA_ACTION: 'data-action',
  DATA_FILTER_ACTION: 'data-filter-action',
  DATA_AUTO_CLOSE_BOUND: 'data-auto-close-bound',
} as const;

export const RESPONSIVE_CONFIG = {
  MOBILE_BREAKPOINT: 768,
} as const;

export const DOM_EVENTS = {
  MOUSE_MOVE: 'mousemove',
  MOUSE_UP: 'mouseup',
  TOUCH_MOVE: 'touchmove',
  TOUCH_END: 'touchend',
  CHILD_LIST: 'childList',
  CLICK: 'click',
} as const;

export const BUTTON_TYPES = {
  FILTER: 'filter',
  RESET: 'reset',
  SUBMIT: 'submit',
} as const;

export const DETECTION_METHODS = {
  SELECTOR: 'selector',
  KEYWORD: 'keyword',
  TYPE: 'type',
} as const;

export const ACCORDION_CONFIG = {
  FIRST_PANEL: 'first',
} as const;

export const FUNCTION_TYPES = {
  FUNCTION: 'function',
} as const;
